import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { getUpdateSubUserForm } from './UpdateSubUserForm.schema';
import { useMutation, useQueryClient } from 'react-query';
import { updateSubUserFormData } from './UpdateSubUserForm.data';
import { UPDATE_SUB_USER_ENT_QUERY_KEY, updateSubUserENTQuery } from './UpdateSubUserForm.query';
import Form from '../../../../../../commons/Form/Form';
import { UpdateSubUserFormSchema } from './UpdateSubUserForm.types';
import Loading from '../../../../../../commons/Loading/Loading';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useMemo } from 'react';
import { ProfileSubUsersENTContext } from '../../ProfileSubUsersENT.context';
import { SubUser } from '../../../../../../../types/models/user/user.types';
import { getSubUserRightLabel, subUserENTRightsList } from '../../../../../../../utils/helpers/user/getSubUserRightLabel';

export default () => {
  const navigate = useNavigate()
  
  const queryClient = useQueryClient()

  const { subUserToUpdate } = useContext(ProfileSubUsersENTContext)

  const formProps = useForm<UpdateSubUserFormSchema>({
    resolver: yupResolver(getUpdateSubUserForm),
    mode: 'onChange',
    reValidateMode: 'onChange'
  })

  const {
    handleSubmit,
    setValue
  } = formProps;

  useEffect(() => {
    if (subUserToUpdate) {
      setValue('firstName', subUserToUpdate.firstName, { shouldValidate: true })
      setValue('lastName', subUserToUpdate.lastName, { shouldValidate: true })
      setValue('email', subUserToUpdate.email, { shouldValidate: true })
      subUserENTRightsList.map((key, index) => {
        subUserToUpdate.rights.split(',').find(item => {
          if (parseInt(item) === index + 1) {
            // @ts-ignore
            setValue(key, true, { shouldValidate: true })
          }
        })
      })
    }
  }, [subUserToUpdate])

  const {
    mutate,
    isLoading
  } = useMutation<Awaited<any>, Error, UpdateSubUserFormSchema>(
    (data) => updateSubUserENTQuery((subUserToUpdate as SubUser).id, data),
    {
      mutationKey: UPDATE_SUB_USER_ENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        navigate(0)
      },
      onError: (error) => alert(error.message),
    }
  )

  const updatedFormData = useMemo(
    () => ([
      ...updateSubUserFormData,
      ...subUserENTRightsList.map((key, index) => [{
        name: key,
        type: 'checkbox',
        label: getSubUserRightLabel(index + 1),
        // checked: subUserToUpdate?.rights.split(',').find(item => parseInt(item) === index + 1)
      }])
    ]),
    [updateSubUserFormData, subUserToUpdate]
  )

  const onSubmit = handleSubmit((data) => mutate(data))

  if (isLoading) return <Loading />

  return (
    <Form<UpdateSubUserFormSchema>
      // @ts-ignore
      data={updatedFormData}
      {...{ formProps, onSubmit }}
      isCompany
    />
  )
}